<template>
  <div id="funcionalidade-customizada-novo">
    <TemplateSolicitacao
      v-if="funcParametros.idTemplateSolicitacao"
      :titulo="tituloNavegacao"
      :id-template="funcParametros.idTemplateSolicitacao"
      :id-funcionalidade="funcionalidade.idFuncionalidade"
      :id-tipo-ocorrencia="funcParametros.idTipoOcorrencia"
      :listagem-popup="listaPopup"
    />
  </div>
</template>

<script>
import TemplateSolicitacao from '@/components/TemplateSolicitacao/TemplateSolicitacao'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'FuncionalidadeCustomizadaNovo',
  components: { TemplateSolicitacao },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    ...mapGetters('Login', ['isLogin']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    funcParametros () {
      return this.funcionalidade.parametros
    },
    listaPopup () {
      // não exibe o popup na listagem, caso não esteja logado
      return !!this.isLogin
    }
  }
}
</script>

<style scoped>
</style>
